import { ref, computed } from 'vue';
import { COMPLETED_PAGES } from './manifest.js';
import { buildHubSections, flattenSectionItems } from './hubCategories.js';

/** 预览站内 /completed-pages 索引：Layout 侧栏与 HubPanel 共用 */
const activeSectionKey = ref('completed');

export function useCompletedHubSectionState(completedPages = COMPLETED_PAGES) {
  const hubSections = computed(() => buildHubSections(completedPages));

  /** 侧栏仅展示基础组件、业务组件（已完成页走下方 manifest 列表） */
  const catalogSections = computed(() =>
    hubSections.value.filter((s) => s.key === 'components' || s.key === 'business'),
  );

  function sectionItemCount(section) {
    return flattenSectionItems(section).length;
  }

  function setActiveSectionKey(key) {
    activeSectionKey.value = key;
  }

  return {
    activeSectionKey,
    hubSections,
    catalogSections,
    sectionItemCount,
    setActiveSectionKey,
  };
}
